import firebase from 'firebase/app'
// Types
import { Match } from '@/types/match'

export class MatchState {
  /**
   * Match object in sync with firestore
   */
  match: Match | null = null

  /**
   * Operations locked
   */
  controlsLocked = true

  realtime: {
    interval: number | null
    timestamp: firebase.firestore.Timestamp
  } = { interval: null, timestamp: firebase.firestore.Timestamp.now() }
}
